var _style, _path, _path2, _path3, _path4, _path5, _defs, _circle, _circle2, _circle3, _defs2, _circle4, _circle5, _circle6, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEpticono(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 340 340",
    style: {
      enableBackground: "new 0 0 340 340"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{display:none}.st1{display:inline}.st3{fill:#4a9cb1}.st4{fill:#021c29}.st5{fill:#8dd0df}.st6{fill:#092f42}.st9{fill:#e2f1f1}.st17{fill:#bee1e5}.st21{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "triste"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141419576377475683680000013756435517949891495_",
    gradientUnits: "userSpaceOnUse",
    x1: 170,
    y1: 327.089,
    x2: 170,
    y2: 12.911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e2f1f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#8dd0df"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141419576377475683680000013756435517949891495_)"
    },
    d: "M170 12.9C83.4 12.9 12.9 83.4 12.9 170S83.4 327.1 170 327.1 327.1 256.6 327.1 170 256.6 12.9 170 12.9z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.3 3.4C81-5.9-5.9 81 3.4 185.3c7.1 79.9 71.4 144.2 151.3 151.4C258.9 346 345.9 259 336.6 154.8c-7.1-80-71.4-144.3-151.3-151.4zm-5.6 24.2c69.4 4.6 126.1 59.9 132.4 129.2 2.3 24.8-1.9 48.4-11 69.4-.2.4-.9 1.9-2.7 2.4-10.8 2.3-23.1 3.7-36.8 3.2-72.8-2.8-82.9-49.7-138.6-47.5-37.4 1.4-53.6 18.8-65.1 29.2-5 4.5-9.3 7.7-13.9 9.5-5.6 1.7-7.3-1.8-8-3.5-5.7-15.4-8.9-32.1-8.9-49.5.2-81.9 69.5-147.9 152.6-142.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.2 247.5c-5-8.8-11.3-16.9-19.1-23.2-3.9-3.1-8.1-5.8-12.6-7.8-1.1-.5-2.3-1-3.4-1.4-1.2-.4-2.4-.8-3.6-1.1-2.4-.7-4.8-1.3-7.2-1.9-2.4-.5-4.9-1-7.3-1.4-2.4-.4-4.9-.6-7.4-.8-4.9-.4-9.9-.4-14.8 0-2.5.2-4.9.5-7.4 1-2.4.4-4.8 1-7.2 1.7-4.8 1.4-9.4 3.4-13.6 6.2 3.5-3.7 8-6.5 12.8-8.5 2.4-1 4.9-1.8 7.4-2.5s5.1-1.2 7.6-1.5c5.1-.8 10.4-.8 15.5-.5 5.2.5 10.3 1.3 15.3 2.7 5 1.3 9.8 3.3 14.5 5.4 4.7 2.3 9 5.3 12.8 8.7 7.7 7.1 13.6 15.7 17.7 24.9zM144.9 244v-.3c0-.1 0-.2-.1-.4s-.2-.5-.4-.7c-.3-.4-.9-.8-1.4-1-1.2-.4-2.8-.6-4.3-.6-3-.1-6.1 0-9.1.5 1.5-.5 3-.8 4.5-1.1 1.5-.3 3-.5 4.6-.6 1.6-.1 3.1-.2 4.8.1 1.7.4 3.6 1.7 3.8 4.1 0 .7-.6 1.2-1.2 1.2-.7 0-1.2-.5-1.2-1.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.7 228.2c-4-3-8.2-5.4-12.6-7.4-.6-.2-1.1-.5-1.7-.7l-1.7-.6-1.7-.7-1.7-.5c-1.2-.4-2.3-.8-3.5-1.1-1.2-.3-2.3-.7-3.5-.9-2.4-.6-4.7-1-7.1-1.4-2.4-.4-4.8-.6-7.3-.9-4.9-.4-9.8-.5-14.7-.4 4.8-1.3 9.8-1.9 14.8-1.9 2.5 0 5 .1 7.5.4 2.5.3 5 .7 7.5 1.2 1.2.2 2.4.6 3.7 1 1.2.3 2.4.7 3.6 1.2l1.8.7 1.7.8 1.7.8c.6.3 1.1.6 1.7.9 4.3 2.5 8.3 5.7 11.5 9.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223.6 178.8c-6.4-1-12.5-2.7-18.5-4.5-6-1.8-11.9-3.8-17.7-6.1-5.9-2.2-11.5-4.7-17.2-7.2-5.7-2.5-11.4-4.8-17.2-7.8 6.5-.3 12.9.5 19.1 1.8 6.3 1.4 12.3 3.4 18.1 5.7 5.9 2.2 11.7 4.8 17.3 7.7 5.5 3.1 11 6.3 16.1 10.4zM128.1 150.2c-6.3 2.1-12.5 3.7-18.8 5.1-6.3 1.4-12.6 2.6-18.9 3.7-6.2 1-12.4 2.2-18.8 3.1-6.4.9-12.9 1.6-19.6 1.3 5.9-3 12-5.3 18.1-7.4 6.1-2.1 12.5-3.8 19-4.9 6.4-1.1 12.9-1.7 19.4-2 6.5-.2 13.1-.1 19.6 1.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M238.9 169.2c-4.3.1-8.6-.3-12.8-1.3-2.1-.5-4.2-1.2-6.2-2.1-1-.4-2-.9-3-1.4-.9-.5-1.9-1.1-2.8-1.7-3.7-2.4-6.9-5.3-9.6-8.8-1.3-1.7-2.5-3.7-3.1-5.8-.7-2.1-.9-4.3-1-6.4.7 2 1.2 4.1 2.1 6 .9 1.9 2.1 3.5 3.4 5.1 1.4 1.6 2.9 3 4.4 4.4 1.6 1.3 3.2 2.7 4.9 3.8 3.5 2.3 7.3 4.1 11.2 5.4 4.1 1.4 8.3 2.2 12.5 2.8zM41.3 154.3c4.3-.6 8.5-1.3 12.5-2.6 2-.6 4-1.3 5.9-2.2 1.9-.9 3.8-1.8 5.5-3 1.8-1.1 3.4-2.4 5.1-3.7 1.6-1.4 3.1-2.8 4.5-4.4 1.4-1.5 2.7-3.2 3.6-5 .9-1.9 1.6-3.9 2.3-6-.2 2.2-.5 4.3-1.2 6.4-.7 2.1-1.9 4.1-3.3 5.8-2.8 3.4-6.1 6.3-9.9 8.6-3.7 2.3-7.9 3.9-12.2 4.9-4.1 1.1-8.5 1.4-12.8 1.2z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000042015365465450338280000000024730064627408524_",
    d: "m206.5 190.7 4.5-20.5-24.9-10-22.1-5.3-.5 22.7 11.4 11z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005241287210048257810000000056760458584677533_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000042015365465450338280000000024730064627408524_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005241287210048257810000000056760458584677533_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000030478732581227092360000017750130311590569866_",
    cx: 855.654,
    cy: 250.605,
    r: 19.034,
    gradientTransform: "scale(-1 1) rotate(-10.568 -126.83 5844.555)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#f7fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#edf7fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    style: {
      stopColor: "#ddf0f5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    style: {
      stopColor: "#c9e7ef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#acdbe7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#8dd0df"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000030478732581227092360000017750130311590569866_)",
      stroke: "#092f42",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 186.9,
    cy: 165.3,
    r: 19
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 192,
    cy: 163.8,
    r: 12.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 185.6,
    cy: 163.1,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 196.4,
    cy: 172.2,
    r: 3.1
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174567054107337414690000016856217197393068694_",
    d: "m117.8 182.6-1.6-32.1-23 2-20.3 3.6.7 18.3 12.6 9.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137105487008393892410000004254257849692298415_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174567054107337414690000016856217197393068694_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137105487008393892410000004254257849692298415_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000068678284920802812760000002269633482344311719_",
    cx: 949.08,
    cy: 254.47,
    r: 19.034,
    gradientTransform: "matrix(-.9973 -.07399 -.07399 .9973 1059.156 -25.718)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#f7fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#edf7fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    style: {
      stopColor: "#ddf0f5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    style: {
      stopColor: "#c9e7ef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#acdbe7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#8dd0df"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000068678284920802812760000002269633482344311719_)",
      stroke: "#092f42",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 93.8,
    cy: 157.8,
    r: 19
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 97.9,
    cy: 154.2,
    r: 12.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 91.9,
    cy: 155.8,
    r: 5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 104.6,
    cy: 160.7,
    r: 2.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.5 180c-6.2-3.2-12.4-6.2-18.7-9-3.2-1.4-6.3-2.8-9.5-4-3.2-1.3-6.4-2.5-9.6-3.7-3.2-1.2-6.5-2.2-9.8-3.1-3.3-1-6.6-1.8-10-2.7-6.7-1.7-13.4-3.3-20.1-5.3 6.9.7 13.8 1.6 20.6 2.8 3.4.6 6.8 1.4 10.2 2.2 3.4.9 6.8 1.9 10.1 3.1 6.5 2.4 13 5.3 19.1 8.6 6.3 3.1 12.3 6.7 17.7 11.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M131.6 150.2c-7 .3-14 .9-20.9 1.5-3.5.4-6.9.7-10.4 1.2-3.4.4-6.9.9-10.3 1.5-3.4.5-6.8 1.2-10.2 2-3.4.7-6.7 1.6-10.1 2.5-6.7 1.7-13.5 3.6-20.4 5 6.5-2.7 13-5.2 19.7-7.4 3.3-1.1 6.7-2.1 10.1-3 3.4-.9 6.9-1.6 10.4-2.2 7-1.1 14-1.8 21-2 7.1-.2 14.2-.1 21.1.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpticono);
export default __webpack_public_path__ + "static/media/EPTICONO.0447395ef8d3f0b6477c14cc72b70335.svg";
export { ForwardRef as ReactComponent };